import { render } from "./event-header.vue?vue&type=template&id=40c93a06"
import script from "./event-header.vue?vue&type=script&lang=js"
export * from "./event-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__